import React from "react";
import { Link } from "react-router-dom";
import "./ProfilePicture.css";

const ProfilePicture = ({ image, name, className, size }) => {
  // Generate initials from name for fallback
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  };

  const initials = getInitials(name);
  const sizeStyle = size ? { width: size, height: size } : {};

  return (
    <div className={`profile-picture-container ${className || ""}`}>
      <div className="profile-picture" style={sizeStyle}>
        {image ? (
          <img src={image} alt={name || "Profile"} className="profile-image" />
        ) : (
          <div className="profile-initials">{initials}</div>
        )}
      </div>
      <h2 className="profile-name">{name || "User"}</h2>
      <div className="paragraph-container">
        <p className="profile-paragraph">
          Nice to meet you! I'm Evey, a multi-platform digital creator based in
          Manchester, UK. Using advanced skills in video editing, Unreal engine,
          3D modelling, VR/AR production, I craft innovative concepts - leading
          trends instead of following them. Take a look at some of the work I've
          done and learn some more about me!
        </p>
        <div className="profile-links">
          <Link to="/photography" className="profile-link photography-link">
            Photography
          </Link>
          <Link to="/media" className="profile-link media-link">
            Media
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProfilePicture;
